export interface MagicLinkTokenResponseInterface {
  magicLinkToken: string;
}
